<template>
    <base-modal
        :reference="'addActivityGroup'"
        :title="'Añadir grupo de actividades'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir un nuevo grupo de actividad en {{suprazone.name}}
                </p>
            </div>
            <form>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            placeholder="Inserte el nombre"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>

                <div class="d-flex my-4 w-100">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label for="" class="mx-2">Punto de inicio/encuentro <span class="text-danger">*</span></label>
                        <v-select
                            :options="geopointsListAdmin"
                            :reduce="(option) => option.id"
                            label="name"
                            v-model="form.geo_point_target_id"
                            style="width: 17vw"
                        >
                        </v-select>
                    </div>
                </div>

                
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Hora de paso <span class="text-danger">*</span></label>
                        <b-form-input
                            type="time"
                            v-model="form.begin_hour"
                            placeholder="Inserte hora de paso"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>

                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Gestionar grupo <span class="text-danger">*</span></label>
                        <v-select
                            :options="booleanOptions"
                            :reduce="(option) => option.value"
                            label="label"
                            v-model="form.manage"
                            style="width: 17vw"
                            class="border"
                        >
                        </v-select>
                    </div>
                </div>

                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        Debe rellenar todos los campos obligatorios
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";

import { mapGetters } from 'vuex'

export default {
    components: {
        BaseModal,
    },
    props: {
        suprazone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            show: false,
            form: {
                name: '',
                geo_point_target_id: 0,
                begin_hour: '08:00',
                manage: false
            },
            booleanOptions: [
                {
                    value: true,
                    label: 'Sí'
                },
                {
                    value: false,
                    label: 'No',
                }
            ],
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addActivityGroup";
            if (modalId == current) {
                this.show = true
                const data = {
                    'suprazone_id': this.suprazone.id,
                }
                await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            
            let data = {
                suprazone_id: this.suprazone.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch("groups/createActivityGroup", data )
            
            

            this.$bvModal.hide("addActivityGroup");
            this.$notify({
                group: "foo",
                title: "Grupo de actividad añadido",
                text: "El nuevo grupo de actividades " + this.form.name + " se ha creado satisfactoriamente",
                type: "success",
            });

            // reset form data
            this.form = {
                name: '',
                geo_point_target_id: 0,
                begin_hour: '08:00'
            }
        }
    },
    computed: {
        ...mapGetters(['geopointsListAdmin', 'isDataLoading']),
        errors() {
            if ( this.form.name == '' || this.form.geo_point_target_id == 0 || this.form.begin_hour == '') {
                return true
            }
            return false
        }
    }
}
</script>